var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.145 9.528 V 1.011 c 0 -0.552 0.448 -1 1 -1 c 0.552 0 1 0.448 1 1 v 8.518 c 0 0.552 -0.448 1 -1 1 C 52.593 10.528 52.145 10.081 52.145 9.528 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.823 57.883 c 0 -0.603 0.229 -1.206 0.688 -1.665 l 9.587 -9.587 c 0.92 -0.918 2.414 -0.918 3.332 0 l 9.447 9.447 l 0 -26.887 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 l 0 29.301 c 0 0.404 -0.243 0.77 -0.617 0.924 c -0.374 0.155 -0.804 0.069 -1.09 -0.217 L 25.015 48.045 c -0.139 -0.139 -0.365 -0.139 -0.505 0.001 l -9.585 9.585 c -0.14 0.139 -0.139 0.365 0 0.504 l 29.781 29.78 c 0.084 0.084 0.191 0.099 0.266 0.096 c 0.15 0.003 0.257 -0.012 0.341 -0.096 l 29.781 -29.78 c 0.18 -0.181 0.184 -0.321 0 -0.504 l -9.585 -9.586 c -0.139 -0.139 -0.365 -0.139 -0.504 0 L 53.852 59.199 c -0.286 0.286 -0.716 0.372 -1.09 0.217 c -0.374 -0.154 -0.617 -0.52 -0.617 -0.924 l 0 -40.141 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 l 0 37.727 l 9.447 -9.447 c 0.919 -0.918 2.414 -0.918 3.332 0 l 9.586 9.586 c 0.891 0.892 0.89 2.444 0 3.332 l -29.78 29.78 c -0.463 0.464 -1.087 0.705 -1.755 0.68 c -0.593 0.025 -1.216 -0.216 -1.68 -0.68 l -29.781 -29.78 C 13.053 59.09 12.823 58.486 12.823 57.883 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.877 20.873 v -8.295 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 8.295 c 0 0.552 -0.447 1 -1 1 S 35.877 21.425 35.877 20.873 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.011 41.544 V 7.318 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 34.226 c 0 0.552 -0.448 1 -1 1 S 44.011 42.096 44.011 41.544 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.fc7571b3e87562d2eb41c2b8f7d87179.svg";
export { ForwardRef as ReactComponent };